export enum ResponseCode {
    Ok = 0,
    Canceled = 1,
    Error = 2
}
